package app.nestbridge.app.usecase

import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.model.AuthSession
import me.tatarka.inject.annotations.Inject

@Inject
class ReadAuthSessionUseCase(
    private val authSessionStore: AuthSessionStore,
) {
    suspend operator fun invoke(): AuthSession? = authSessionStore.read()
}
